import React from "react";
import { Nav } from "@/components/landing/Nav";
import { Banner } from "@/components/landing/Banner";
import { Hero } from "@/components/landing/Hero";
import { QuestionDeck } from "@/components/landing/QuestionDeck";
import { ModelSection } from "@/components/landing/ModelSection";
import { Outcomes } from "@/components/landing/Outcomes";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

export default function LandingPage() {
  useSmoothScroll();

  return (
    <>
      <a
        href="#model"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-[color:var(--navy)] focus:shadow-lg"
      >
        Skip to content
      </a>
      <Nav />
      <main id="main">
        <Banner />
        <Hero />
        <QuestionDeck />
        <ModelSection />
        <Outcomes />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
